import { useContext } from "react";
import { LangContext } from "./LangContext";

const TIER_FILTERS = [
  ["gun",       "Smoking Gun"],
  ["watershed", "Watershed"],
  ["notable",   "Notable"],
  ["common",    "Common"],
];
const DIR_FILTERS_KO = [["up", "확전"], ["down", "진정"]];
const DIR_FILTERS_EN = [["up", "Escalation"], ["down", "De-escalation"]];
const SORT_FILTERS_KO = [["priority", "중요도순"], ["time", "시간순"]];
const SORT_FILTERS_EN = [["priority", "Priority"], ["time", "Time"]];

function SegGroup({ children }) {
  return (
    <div style={{
      display: "inline-flex", alignItems: "center",
      background: "#26282c", borderRadius: 9, padding: 3, gap: 1,
    }}>{children}</div>
  );
}

function SegChip({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: active ? "#43464b" : "transparent",
        border: "none",
        color: active ? "#ffffff" : "var(--pc-fg-3)",
        padding: "5px 11px",
        fontSize: 11.5,
        fontWeight: active ? 700 : 500,
        letterSpacing: ".005em",
        fontFamily: "var(--pc-font-sans)",
        cursor: "pointer",
        borderRadius: 6,
        whiteSpace: "nowrap",
        transition: "all 120ms var(--pc-ease-out)",
        lineHeight: 1.3,
      }}
    >{children}</button>
  );
}

export default function PCFilterBar({ filters, setFilters }) {
  const lang = useContext(LangContext);
  const dirFilters  = lang === "en" ? DIR_FILTERS_EN  : DIR_FILTERS_KO;
  const sortFilters = lang === "en" ? SORT_FILTERS_EN : SORT_FILTERS_KO;
  const toggleSet = (key, val) => {
    setFilters(f => {
      const cur = new Set(f[key]);
      cur.has(val) ? cur.delete(val) : cur.add(val);
      return { ...f, [key]: cur };
    });
  };
  const setSort = (val) => setFilters(f => ({ ...f, sort: val }));

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 14,
      padding: "10px 24px", borderBottom: "1px solid var(--pc-line-3)",
      overflowX: "auto", background: "var(--pc-bg-1)",
    }}>
      <SegGroup>
        <SegChip active={filters.tier.size === 0} onClick={() => setFilters(f => ({ ...f, tier: new Set() }))}>All</SegChip>
        {TIER_FILTERS.map(([id, label]) => (
          <SegChip key={id} active={filters.tier.has(id)} onClick={() => toggleSet("tier", id)}>{label}</SegChip>
        ))}
      </SegGroup>
      <SegGroup>
        <SegChip active={filters.dir.size === 0} onClick={() => setFilters(f => ({ ...f, dir: new Set() }))}>All</SegChip>
        {dirFilters.map(([id, label]) => (
          <SegChip key={id} active={filters.dir.has(id)} onClick={() => toggleSet("dir", id)}>{label}</SegChip>
        ))}
      </SegGroup>
      <SegGroup>
        {sortFilters.map(([id, label]) => (
          <SegChip key={id} active={filters.sort === id} onClick={() => setSort(id)}>{label}</SegChip>
        ))}
      </SegGroup>
    </div>
  );
}
